import BreadcrumMenu from 'organization/theme/Breadcrum'
import React, {useState} from 'react'
import styled from 'styled-components'
import CompanySettings from 'organization/OrganizationSettings/CompanySettings'
import PaymentsSettings from 'organization/OrganizationSettings/PaymentsSettings'
import OrganizationPage from 'organization/theme/OrganizationPage'
import {EventFaqHelp} from 'organization/Event/Help/FAQ'
import {useI18n} from 'i18n/I18nContext'

type TabKey = 'payments' | 'company'
export const OrganizationSettings = () => {
  const {t} = useI18n()
  const [tab, setTab] = useState<TabKey>('payments')

  return (
    <OrganizationPage>
      <div className="row pl-30 pb-30 pr-30">
        <BreadcrumMenu
          title={t('org.menu.earnings')}
          helpInfo={<EventFaqHelp faqKey="profitPage" />}
        />

        <Tabs>
          <TabButton
            $active={tab === 'payments'}
            onClick={() => setTab('payments')}
          >
            Stripe
          </TabButton>
          <TabButton
            $active={tab === 'company'}
            onClick={() => setTab('company')}
          >
            {t('org.menu.companyTab')}
          </TabButton>
        </Tabs>
        {tab === 'payments' && <PaymentsSettings />}
        {tab === 'company' && <CompanySettings />}
      </div>
    </OrganizationPage>
  )
}

const Tabs = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 18px;
`

const TabButton = styled.button<{$active: boolean}>`
  padding: 12px 18px;
  border-radius: 8px;
  border: 2px solid ${({$active}) => ($active ? '#f7426f' : '#e6e6e6')};
  background: ${({$active}) => ($active ? 'rgba(247,66,111,0.12)' : '#fff')};
  color: ${({$active}) => ($active ? '#f7426f' : '#666')};
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: ${({$active}) => ($active ? '#f7426f' : '#d0d0d0')};
    background: ${({$active}) =>
      $active ? 'rgba(247,66,111,0.15)' : '#f5f5f5'};
  }

  &:active {
    transform: scale(0.98);
  }
`
